const clearedPreviewFields = () => {
  return {
    to: '',
    subject: '',
    from: '',
    html: '',
    hsmParams: [],
    attachments: [],
    richCards: [],
    rcsActions: []
  }
}

export { clearedPreviewFields }
